import { observer } from "mobx-react-lite";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { SearchScene } from "triangular/components/SearchSceneLayout/SearchSceneLayout";
import { SearchSelector } from "triangular/components/SearchSelector/SearchSelector";

import css from "./DesktopViewContent.module.scss";
import { ExpertList } from "./ExpertList";
import { ExpertsCount } from "./ExpertsCount";
import { Industries } from "./filters/Industries";
import { Languages } from "./filters/Languages";
import { MaterialCategories } from "./filters/MaterialCategories";
import { ProcessCategories } from "./filters/ProcessCategories";
import { Search } from "./Search";
import { SearchPhrase } from "./SearchPhrase";
import { useFilterBadges } from "./utils/useFilterBadges";

export const DesktopViewContent = observer(() => {
  const filterBadges = useFilterBadges();
  const { t } = useTranslation();
  return (
    <>
      <Container fluid className={css.container}>
        <Row className="justify-content-md-center">
          <Col md={2}>
            <SearchSelector className={css.circle} position={css.position} logoSize={css.logo} />
          </Col>
          <Col md={"auto"}>
            <h1 className={css.title}>{t("expertsSearch.sectionHeader")}</h1>
          </Col>
        </Row>
      </Container>
      <SearchScene.DesktopViewContent
        searchSection={<Search />}
        searchPhraseSection={<SearchPhrase />}
        sortSection={<ExpertsCount />}
        basicFilters={
          <>
            <Languages />
            <ProcessCategories />
            <Industries />
            <MaterialCategories />
          </>
        }
        filterBadges={filterBadges}
        results={<ExpertList />}
      />
    </>
  );
});
